// Full-document render of the lookup-orders-by-email confirmation page:
// PageSkeleton wrapping the account-page layout -- the brand heading, the
// static confirmation copy, and the decorative account image. The heading /
// paragraphs / image diverge per APP_SLUG, so they arrive pre-resolved as
// props from the server-side lookup_orders_copy hook (request-time gettext,
// keeping tempurca fr_CA translated).
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailConfirmationDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <div className="account-page-title">
                    <h1>{props.page_heading}</h1>
                </div>

                <section className="account-page-container">
                    <div>
                        <h2>{props.heading}</h2>
                        <div>
                            {props.paragraphs.map((paragraph, index) => (
                                <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                    <div>
                        <img
                            src={`${staticURL}img/accounts/${props.image}`}
                            alt={props.image_alt}
                        />
                    </div>
                </section>
            </div>
        </PageSkeleton>
    );
};
